<p-toast></p-toast>

<ng-container *ngIf="useDialog ?? true">
	<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" [style]="{width: '800px'}" (onHide)="cancel()">
		<div class="worker-container">
			<form [formGroup]="form" class="worker-form">
				<h2 class="text-xl font-semibold text-center mt-2 mb-4">{{ mode === 'create' ?
					(translateServ.dictionary['WORKER_CREATE'] || 'Create Worker') :
					(translateServ.dictionary['WORKER_EDIT'] || 'Edit Worker') }}</h2>

				<div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
					<!-- Group 1: Name (EN + HE) -->
					<div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
						<div class="field w-full">
							<label>First Name <span class="required">*</span></label>
							<input pInputText formControlName="FirstName" class="w-full" />
							<small class="error"
								*ngIf="form.get('FirstName')?.touched && form.get('FirstName')?.invalid">First name is
								required</small>
						</div>
						<div class="field w-full">
							<label>Last Name <span class="required">*</span></label>
							<input pInputText formControlName="LastName" class="w-full" />
							<small class="error"
								*ngIf="form.get('LastName')?.touched && form.get('LastName')?.invalid">Last name is
								required</small>
						</div>
						<div class="field w-full">
							<label>First Name (HE)</label>
							<input pInputText formControlName="FirstName_HE" class="w-full" />
							<small class="error"
								*ngIf="form.get('FirstName_HE')?.touched && form.get('FirstName_HE')?.errors?.['pattern']">Only
								Hebrew letters and spaces allowed</small>
						</div>
						<div class="field w-full">
							<label>Last Name (HE)</label>
							<input pInputText formControlName="LastName_HE" class="w-full" />
							<small class="error"
								*ngIf="form.get('LastName_HE')?.touched && form.get('LastName_HE')?.errors?.['pattern']">Only
								Hebrew letters and spaces allowed</small>
						</div>
					</div>

					<!-- Group 2: Connection (User + Email) -->
					<div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
						<div class="field w-full">
							<label>User Name <span class="required">*</span></label>
							<input pInputText formControlName="UserName" class="w-full" />
							<small class="error" *ngIf="form.get('UserName')?.errors?.['exists']">User name already exists</small>
						</div>
						<div class="field w-full">
							<label>Email <span class="required">*</span></label>
							<input pInputText formControlName="Email" class="w-full" />
							<small class="error" *ngIf="form.get('Email')?.touched && form.get('Email')?.invalid">Enter
								a valid email</small>
							<small class="error" *ngIf="form.get('Email')?.errors?.['exists']">Email already exists</small>
						</div>

						<div class="field w-full">
							<label>Role <span class="required">*</span></label>
							<p-autoComplete formControlName="Role" [suggestions]="filteredRoleOptions"
								(completeMethod)="filterRoleOptions($event)" (onSelect)="onRoleSelect($event)"
								[forceSelection]="true" [dropdown]="true" [minLength]="0" field="label"
								class="w-full max-w-xs mx-auto text-center" appendTo="body">
							</p-autoComplete>
							<small class="error" *ngIf="form.get('Role')?.touched && form.get('Role')?.invalid">Role is
								required</small>
						</div>

						<div class="field w-full password-field">
													<label class="flex items-center justify-center gap-1">
														<button *ngIf="mode === 'create'" pButton type="button"
															class="p-button-text p-button-sm p-button-icon-only m-0 p-0"
															pTooltip="Generate password" tooltipPosition="top" (click)="createTempPass()">
															<i class="pi pi-sparkles password-icon" aria-hidden="true"></i>
														</button>
														<span>Password {{ mode === 'create' ? '*' : '' }}</span>
													</label>
													<p-password formControlName="Pass" [feedback]="false" [toggleMask]="true"
														styleClass="w-full" inputStyleClass="w-full"></p-password>

						</div>
					</div>

					<!-- Group 3: Additional (Phone + Notes) -->
					<div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
						<div class="field w-full">
							<label>Phone (optional)</label>
							<div class="flex gap-2 justify-center">
								<ng-container *ngIf="!dirServ.isRtl(); else rtlPhoneOrder">
									<p-autoComplete formControlName="PhonePref" [suggestions]="filteredPhonePrefixes"
										(completeMethod)="filterPhonePrefixes($event)"
										(onSelect)="onPhonePrefSelect($event)" [forceSelection]="true" [dropdown]="true"
										appendTo="body" [minLength]="0" placeholder="Prefix"
										styleClass="w-5rem"></p-autoComplete>
									<input pInputText maxlength="7" class="w-full max-w-xs"
										formControlName="PhoneNumber" placeholder="7 digits" />
								</ng-container>
								<ng-template #rtlPhoneOrder>
									<input pInputText maxlength="7" class="w-full max-w-xs"
										formControlName="PhoneNumber" placeholder="7 digits" />
									<p-autoComplete formControlName="PhonePref" [suggestions]="filteredPhonePrefixes"
										(completeMethod)="filterPhonePrefixes($event)"
										(onSelect)="onPhonePrefSelect($event)" [forceSelection]="true" [dropdown]="true"
										appendTo="body" [minLength]="0" placeholder="Prefix"
										styleClass="w-5rem"></p-autoComplete>
								</ng-template>
							</div>
							<small class="error"
								*ngIf="form.get('PhoneNumber')?.touched && form.get('PhoneNumber')?.invalid">Enter a
								7-digit phone number</small>
						</div>

						<div class="field w-full">
							<label>Notes</label>
							<textarea pInputText rows="4" formControlName="Notes"
								class="w-full max-w-xs mx-auto text-center"></textarea>
						</div>

						<div class="mt-4 actions w-full flex justify-center gap-4">
							<button pButton type="button" label="Cancel" class="p-button-text"
								(click)="cancel()"></button>
							<button pButton type="button" label="Save" class="p-button-primary"
									(click)="save()" [disabled]="form.invalid"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</p-dialog>
</ng-container>

<!-- Page mode: render the same content without dialog wrapper -->
<ng-container *ngIf="!(useDialog ?? true)">
	<p-toast></p-toast>
	<div class="worker-container page-mode p-4">
		<form [formGroup]="form" class="worker-form">
			<h2 class="text-xl font-semibold text-center mt-2 mb-4">{{ mode === 'create' ?
				(translateServ.dictionary['WORKER_CREATE'] || 'Create Worker') :
				(translateServ.dictionary['WORKER_EDIT'] || 'Edit Worker') }}</h2>

			<div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
				<!-- Group 1: Name -->
				<div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
					<div class="field w-full">
						<label>First Name <span class="required">*</span></label>
						<input pInputText formControlName="FirstName" class="w-full" />
						<small class="error"
							*ngIf="form.get('FirstName')?.touched && form.get('FirstName')?.invalid">First name is
							required</small>
					</div>
					<div class="field w-full">
						<label>Last Name <span class="required">*</span></label>
						<input pInputText formControlName="LastName" class="w-full" />
						<small class="error" *ngIf="form.get('LastName')?.touched && form.get('LastName')?.invalid">Last
							name is required</small>
					</div>
					<div class="field w-full">
						<label>First Name (HE)</label>
						<input pInputText formControlName="FirstName_HE" class="w-full" />
						<small class="error"
							*ngIf="form.get('FirstName_HE')?.touched && form.get('FirstName_HE')?.errors?.['pattern']">Only
							Hebrew letters and spaces allowed</small>
					</div>
					<div class="field w-full">
						<label>Last Name (HE)</label>
						<input pInputText formControlName="LastName_HE" class="w-full" />
						<small class="error"
							*ngIf="form.get('LastName_HE')?.touched && form.get('LastName_HE')?.errors?.['pattern']">Only
							Hebrew letters and spaces allowed</small>
					</div>
				</div>

				<!-- Group 2: Connection -->
				<div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
					<div class="field w-full">
						<label>User Name <span class="required">*</span></label>
						<input pInputText formControlName="UserName" class="w-full" />
						<small class="error" *ngIf="form.get('UserName')?.errors?.['exists']">User name already exists</small>
					</div>
					<div class="field w-full">
						<label>Email <span class="required">*</span></label>
						<input pInputText formControlName="Email" class="w-full" />
						<small class="error" *ngIf="form.get('Email')?.touched && form.get('Email')?.invalid">Enter a
							valid email</small>
						<small class="error" *ngIf="form.get('Email')?.errors?.['exists']">Email already exists</small>
					</div>
					<div class="field w-full">
						<label>Role <span class="required">*</span></label>
						<p-autoComplete formControlName="Role" [suggestions]="filteredRoleOptions"
							(completeMethod)="filterRoleOptions($event)" (onSelect)="onRoleSelect($event)"
							[forceSelection]="true" [dropdown]="true" [minLength]="0" field="label"
							class="w-full max-w-xs mx-auto text-center" appendTo="body">
						</p-autoComplete>
						<small class="error" *ngIf="form.get('Role')?.touched && form.get('Role')?.invalid">Role is
							required</small>
					</div>
					<div class="field w-full password-field">
												<label>Password {{ mode === 'create' ? '*' : '' }}</label>
												<div class="password-wrapper flex align-items-center gap-2">
													<p-password formControlName="Pass" [feedback]="false" [toggleMask]="true"
														class="w-full max-w-xs"></p-password>
													<i class="pi pi-sparkles password-icon" aria-hidden="true" title="Nice"></i>
												</div>
					</div>
				</div>

				<!-- Group 3: Additional -->
				<div class="flex flex-col gap-6 items-center text-center border rounded-lg shadow-sm p-6 bg-white">
					<div class="field w-full">
						<label>Phone (optional)</label>
						<div class="flex gap-2 justify-center">
							<ng-container *ngIf="!dirServ.isRtl(); else rtlPhoneOrderPage">
								<p-autoComplete formControlName="PhonePref" [suggestions]="filteredPhonePrefixes"
									(completeMethod)="filterPhonePrefixes($event)"
									(onSelect)="onPhonePrefSelect($event)" [forceSelection]="true" [dropdown]="true"
									appendTo="body" [minLength]="0" placeholder="Prefix"
									styleClass="w-5rem"></p-autoComplete>
								<input pInputText maxlength="7" class="w-full max-w-xs" formControlName="PhoneNumber"
									placeholder="7 digits" />
							</ng-container>
							<ng-template #rtlPhoneOrderPage>
								<input pInputText maxlength="7" class="w-full max-w-xs" formControlName="PhoneNumber"
									placeholder="7 digits" />
								<p-autoComplete formControlName="PhonePref" [suggestions]="filteredPhonePrefixes"
									(completeMethod)="filterPhonePrefixes($event)"
									(onSelect)="onPhonePrefSelect($event)" [forceSelection]="true" [dropdown]="true"
									appendTo="body" [minLength]="0" placeholder="Prefix"
									styleClass="w-5rem"></p-autoComplete>
							</ng-template>
						</div>
						<small class="error"
							*ngIf="form.get('PhoneNumber')?.touched && form.get('PhoneNumber')?.invalid">Enter a 7-digit
							phone number</small>
					</div>

					<div class="field w-full">
						<label>Notes</label>
						<textarea pInputText rows="4" formControlName="Notes"
							class="w-full max-w-xs mx-auto text-center"></textarea>
					</div>

					<div class="mt-4 actions w-full flex justify-center gap-4">
						<button pButton type="button" label="Cancel" class="p-button-text" (click)="cancel()"></button>
						<button pButton type="button" label="Save" class="p-button-primary" (click)="save()" [disabled]="form.invalid"></button>
					</div>
				</div>
			</div>
		</form>
	</div>
</ng-container>